<template>
  <div class="home">
    <h1>
      Welcome
    </h1>

    <p>
      Comming Soon
    </p>
  </div>
</template>

<script>
export default {
  name: "Newpage"
};
</script>
